import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './GroupClassAndActivity.scss'
import { useDispatch, useSelector } from 'react-redux';
import backArrow from '../../assets/images/back-arrow.svg'
import moment from 'moment';
// import calendarIcon from '../../assets/images/calendarIcon.png'
import "react-datepicker/dist/react-datepicker.css";
import { addActiveUsersListToGroupActivity, clearActivityDeatils, getActiveUsersListForGroupActivity, getActivityDeatils, getActivityListByDate } from '../../redux/actions/GroupClassesAndActivityActions/GroupClassesAndActivityAction';
import Select from "react-select";
import { notify } from '../../utils/notification';
import { CircularProgress } from '@mui/material';
import { GROUP_CLASSESS_AND_ACTIVITY_ENDPOINT, VIEW_GUEST_LIST_ENDPOINT } from '../../routes/route';
import DatePicker from '../../components/DatePicker/DatePicker';
import MultiSelectWithInfiniteScroll from '../../components/MultiSelect/MultiSelectWithInfiniteScroll';
import Button from '../../components/Form Components/Button';
import  {ReactComponent as AddIcon} from '../../assets/images/add.svg'


function GroupClassAndActivity() {
    const location = useLocation()
    const activityName = location?.state?.activityName;
    const selectedDate = location?.state?.selectedDate;
    const [name, setName] = useState(activityName || '');
    const [date, setDate] = useState(selectedDate || new Date());
    const [activitynameOptions, setActivityNameOptions] = useState([])
    const [frequency, setFrequency] = useState(null);
    const [bookedUsers, setBookedUsers] = useState(0);
    const [addUsers, setAddUsers] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const {loading, activityList, activityDetails, loadingActivityList, activeGuestList, loadingActiveGuestList, updateLoading} = useSelector(state=> state.groupClassesAndActivityReducer)

    const navigate = useNavigate()

    const fetchUsers = ({page=1, limit=10, searchText=""} = {})=>{
      setAddUsers(true)
      dispatch(getActiveUsersListForGroupActivity({id: name?.value, page, limit, searchText}))
    }

    const handleSelectUsers = (selectedOptions)=>{
      setSelectedUsers(selectedOptions)
    }

    const handleSearch = ()=>{
        if(!name)
            notify('warning', 'Please Select activity')
        else
        navigate({
            pathname: GROUP_CLASSESS_AND_ACTIVITY_ENDPOINT,
        }, {state: {activityName: name,selectedDate: date},replace: true })
    }

    const handleAdd =(selectedOptions, closeMenu)=>{
      if(selectedOptions?.length){
        dispatch(addActiveUsersListToGroupActivity({
          activityId: name?.value,
          users: selectedOptions.map((item)=>item.value),
          onSuccessCallback: ()=>{
              closeMenu()
              setBookedUsers(prev=> prev + selectedOptions?.length)
              setSelectedUsers([])
            }
        }))
      }
    }

    const dispatch = useDispatch()

    useEffect(()=>{
        let data = {
            date: moment(date).format('YYYY-MM-DD')
        }
        dispatch(getActivityListByDate(data))
        return(()=>{
            dispatch(clearActivityDeatils())
        })
    },[])


    useEffect(()=>{
        if(name){
            dispatch(getActivityDeatils({activityId: name?.value}))
        }
    },[location.state])

    useEffect(()=>{
        if(activityDetails){
          setFrequency(activityDetails && activityDetails?.frequency && JSON.parse(activityDetails?.frequency))
          setBookedUsers(activityDetails?.booked_user)
        }
    }, [activityDetails])

    useEffect(()=>{
        if(activityList?.length){
            let newArr = activityList.map((item) => {
                return { value: item.activity_id, label: item.title };
             });
            setActivityNameOptions(newArr)
        }else{
            setActivityNameOptions([])
        }
    },[activityList])
    
  return (
    <>
            <div className="group-activity-container">
                <div className="container h-100">
                    <div className="group-activity-heading">
                        <img className='back-arrow' src={backArrow} width={'23px'} alt="" onClick={()=>navigate(-1)} />
                        &nbsp;
                        Group Classes / Activity
                    </div>
                    <div className="pt-4 pb-5">
                        <div className="group-activity-content p-4">
                          <div className="d-flex filter">
                            <div className='d-flex'>
                                <DatePicker
                                    onChange={date => { setDate(date); setName(''); dispatch(getActivityListByDate({date: moment(date).format('YYYY-MM-DD')})) }}
                                    value={date}
                                    className={'activity-date'}
                                />
                                <Select
                                    className="name-select ms-2"
                                    classNamePrefix="select"
                                    isLoading={loadingActivityList}
                                    isClearable={true}
                                    isSearchable={true}
                                    name="color"
                                    options={activitynameOptions}
                                    placeholder='Select Activity'
                                    onChange={(e)=>{setName(e)}}
                                    value={name}
                                />

                            </div>
                            <button className='search-btn' onClick={handleSearch} > SEARCH </button>
                         </div>
                         <hr />
                        <div className='activity-details '>
                            {
                                loading ?
                                <div className='text-center'><CircularProgress sx={{'color': '#74613C'}}/></div>
                                :
                                <> 
                                    {
                                        activityDetails && 
                                        <>
                                            <div className='active-users-select'>
                                                {
                                                    !addUsers ?
                                                    <Button
                                                        loading={false}
                                                        content={'Add Guest'}
                                                        icon={<AddIcon/>}
                                                        className={'add-guest-btn mx-auto mb-3'}
                                                        onClick={fetchUsers}
                                                    />
                                                    :
                                                    <>
                                                        <MultiSelectWithInfiniteScroll
                                                            loading={loadingActiveGuestList}
                                                            options={[
                                                                ...(activeGuestList?.data ? activeGuestList?.data?.map((item)=>({
                                                                label:item.full_name,
                                                                value: item.user_program_id
                                                                })) : []
                                                                    )
                                                                ]}
                                                                className='name-select  mb-3'
                                                                defaultValue={selectedUsers}
                                                                onClickOk={handleAdd}
                                                                hasSelectAllOption={false}
                                                                updateLoading={updateLoading}
                                                                placeholder={'Add Guest...'}
                                                                submitText={'Add'}
                                                            />
                                                    </>
                                                }
                                            </div>
                                            <div>
                                                <div className="activity-title mb-4">
                                                    {activityDetails?.title}
                                                </div>
                                                <div className="activity-row">
                                                    <div className="label">Capacity:</div>
                                                    <div className="value">{activityDetails?.no_of_capacity || '-'}</div>
                                                </div>
                                                <div className="activity-row">
                                                    <div className="label">Book User:</div>
                                                    <div className="value">{bookedUsers?.toString() || '-'} {!!bookedUsers && <Link to={VIEW_GUEST_LIST_ENDPOINT} state={{id: activityDetails.id, title: activityDetails?.title}}>(View Guest List)</Link>} </div>
                                                </div>
                                                <div className="activity-row">
                                                    <div className="label">Venue:</div>
                                                    <div className="value">{activityDetails?.venue || '-'}</div>
                                                </div>
                                                <div className="activity-row">
                                                    <div className="label">Date:</div>
                                                    <div className="value">{moment(activityDetails?.activity_datetime).format('DD/MM/YYYY') || '-'}</div>
                                                </div>
                                                <div className="activity-row">
                                                    <div className="label">Time:</div>
                                                    <div className="value">{moment(activityDetails?.activity_datetime).format('HH:mm:ss') || '-'}</div>
                                                </div>
                                                <div className="activity-row">
                                                    <div className="label">Repeat Activity:</div>
                                                    <div className="value">{activityDetails?.is_repeated ==='1' ? 'Yes' :  'No'}</div>
                                                </div>
                                                {
                                                    activityDetails?.is_repeated === '1'? 
                                                    <div className="activity-row">
                                                        <div className="label">Frequency:</div>
                                                            {frequency?.key} &nbsp;
                                                            {
                                                                frequency?.key === "weekly"
                                                                ?
                                                                <>
                                                                    
                                                                    [{
                                                                        frequency?.value.map((item, index)=>(
                                                                            <React.Fragment>
                                                                                {item.value ? item.day : null}
                                                                                {item.value && index !== frequency?.value.length-1 ? ", " : null}
                                                                            </React.Fragment>
                                                                        ))
                                                                    }]
                                                                </>
                                                                :
                                                                null
                                                            }
                                                        <div className="value">
                                                        </div>
                                                    </div>
                                                    :
                                                    null
                                                }
                                                <div className="activity-row">
                                                    <div className="label">Duration:</div>
                                                    <div className="value">{`${activityDetails?.duration} Minutes` || '-'}</div>
                                                </div>
                                                <div className="activity-row">
                                                    <div className="label">Notes:</div>
                                                    <div className="value">{activityDetails?.notes || '-'}</div>
                                                </div>
                                            </div>
                                          
                                        </>
                                    }
                                </>
                            }
                        </div>
                            
                        </div>
                    </div>                                  
                </div>
            </div>
        </>
  )
}

export default GroupClassAndActivity